export default "__VITE_ASSET__DDP7vWrY__"